module.exports = __webpack_public_path__ + "static/media/rangqi.c0254f13.gif";